import React, { useState } from 'react';
import { Link, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import AuthCard from '../components/AuthCard';
import TextField from '../components/TextField';
import PasswordField from '../components/PasswordField';
import { Alert, SubmitButton } from '../components/Feedback';
import { usePspAuth } from '../context/PspAuthContext';
import { candidateApi } from '../services/pspApi';

const Login = () => {
    const { friendly_url } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated, signIn } = usePspAuth();
    const base = `/processos-seletivos/${friendly_url}`;

    const [form, setForm] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const returnDestination = (location.state && location.state.returnTo) || `${base}/home`;

    if (isAuthenticated) {
        return <Navigate to={returnDestination} replace />;
    }

    const handleChange = (name, value) => setForm((current) => ({ ...current, [name]: value }));

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setLoading(true);
        const result = await candidateApi.login(form.email, form.password);
        setLoading(false);

        if (result && result.status === 1) {
            signIn(result.token, result.candidate);
            navigate(returnDestination, { replace: true });
        } else {
            setError((result && result.message) || 'Não foi possível entrar. Tente novamente.');
        }
    };

    return (
        <div className="psp-center psp-center--padded">
            <AuthCard
                icon="fa-user"
                title="Acesso do Candidato"
                subtitle="Informe seu e-mail e senha para acessar a sua conta."
            >
                <form className="psp-stack" onSubmit={handleSubmit} noValidate>
                    <Alert type="error">{error}</Alert>
                    <TextField name="email" type="email" label="E-mail" value={form.email} onChange={handleChange} required autoComplete="email" />
                    <PasswordField name="password" label="Senha" value={form.password} onChange={handleChange} required />
                    <div className="psp-text-right">
                        <Link className="psp-link" to={`${base}/recuperar-senha`}>
                            Esqueci minha senha
                        </Link>
                    </div>
                    <SubmitButton loading={loading}>Entrar</SubmitButton>
                    <div className="psp-divider">ou</div>
                    <button type="button" className="psp-btn psp-btn--outline" onClick={() => navigate(`${base}/cadastro`)}>
                        Criar Conta Gratuita
                    </button>
                </form>
            </AuthCard>
        </div>
    );
};

export default Login;
